import { lazyWithRetry } from "utils/lazy-with-retry";
import { ICreateEditReviewTemplateProps } from "./definitions";

const LazyCreateEditReviewTemplate = lazyWithRetry(
  () => import("./CreateEditReviewTemplate"),
);

const CreateEditReviewTemplate = (
  props: JSX.IntrinsicAttributes & ICreateEditReviewTemplateProps,
) => <LazyCreateEditReviewTemplate {...props} />;

export default CreateEditReviewTemplate;
